import { Box, FormControl, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";

const formatUserLabel = user => {
  const name = [user.firstName, user.secondName, user.lastName].filter(Boolean).join(" ");
  const personId = user.personId ? ` (${user.personId})` : "";
  return `${name}${personId}`;
};

const UserPicker = ({ users, selectedIndex, onChange }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Paper sx={{ backgroundColor: "warning.light", border: "1px solid #BEBEBE", p: 4 }}>
        <Typography
          color="primary"
          sx={{ mb: 1, fontWeight: "bold" }}
        >
          Намерен е повече от един специализант със същото ЕГН (идентификатор). Изберете един:
        </Typography>
        <FormControl>
          <RadioGroup
            value={String(selectedIndex)}
            onChange={e => onChange(Number(e.target.value))}
          >
            {users.map((user, idx) => (
              <FormControlLabel
                key={user.userUId ?? user.userId ?? idx}
                value={String(idx)}
                control={<Radio />}
                label={formatUserLabel(user)}
                sx={{ border: "1px solid #BEBEBE", mb: 0.5 }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Paper>
    </Box>
  );
};

export default UserPicker;
